import React, { useEffect, useRef, useState } from 'react'
import { addToastMsg, initProvider, onNetworkChange } from '../services/amm'
import { getExplorerUrlBase } from '../services/wallet.service'
import { StyledButtonTypography, StyledLoadingButton } from './StyleCustomizations'
// import { GAbutton, GAtrack } from '../services/ga'
import { Button } from '@mui/material'
import ArgentLogo from '../images/logo/Argent-x-logo.png'
import ConnectedWalletOptions from './ConnectedWalletOptions'
import useIsMobile from '../hooks/useIsMobile'
import { useWalletContext } from './WalletContext'
import { BraavosLogo } from '../svgIcons/BraavosLogo'
import PrimaryButton from './PrimaryButton'
import { getSNSFromAddress } from '../blockchainUtils'
import { humanReadableHash, shortenText } from '../blockchainUtils/general'
import { Network } from '../services/token.service'
import StarknetLogo from '../images/icons/starknetLogo.png'
import { GAtrack } from '../services/ga'

function ConnectWallet(props: { secondary?: any; connected?: () => void; disconnected?: () => void }) {
    const [walletConnectionStatus, setWalletConnectionStatus] = useState(0)
    const { networkName: network, walletAddress: address, connect, disconnect: walletDisconnect } = useWalletContext()
    const [openConnectedOptions, setOpenConnectedOptions] = useState(false)
    const [autoConnect, setAutoConnect] = useState(true)
    // const [anchorEl, setAnchorEl] = useState()
    const [starknetReadableAddress, setStarknetReadableAddress] = useState('')

    const isMobile = useIsMobile()

    // useEffect(() => {
    //     if
    // }, [openConnectedOptions])

    useEffect(() => {
        if (address && network) getSNS()
    }, [address, network])

    async function getSNS() {
        try {
            await initProvider(network as Network)
            const response = await getSNSFromAddress(network as Network, address!, true)
            // console.log('getSNS response ', response)
            setStarknetReadableAddress(response!.name)
        } catch (e: any) {
            console.log('FAILED SNS ', e.message)
            setStarknetReadableAddress('')
        }
    }

    useEffect(() => {
        if (address) {
            setWalletConnectionStatus(2)
            try {
                const name = window.getStarknet?.()?.name!
                GAtrack('wallet_address_change', name, name)
                console.log('YSYS GATrack ', name)
            } catch {}
        }
    }, [address])

    async function handleClick() {
        connect()
        // GAbutton('connect_wallet')
        // setWalletConnectionStatus(1)
        // try {
        //     console.log('LOGIN')
        //     // let connected = await connect(autoConnect)
        //     // if (!connected && autoConnect) {
        //     //     setAutoConnect(false)
        //     //     connected = await connect(false)
        //     // }
        //     // if (!connected) {
        //     //     throw new Error('No wallet address found')
        //     // }
        // } catch (e) {
        //     // this means no argent wallet is available
        //     console.log('connectWallet throw an exception', e)
        //     //addToastMsg('Wallet not found', 'error')
        //     setWalletConnectionStatus(0)
        //     return
        // }
        // setWalletConnectionStatus(2)
        // if (!props.secondary) {
        //     props.connected?.()
        // }
        // // addToastMsg('Wallet connected', 'success')
        // const name = window.getStarknet?.()?.name ?? 'noname'
        // // console.log('wallet name: ', name)
        // if (network === 'mainnet-alpha') GAtrack(`wallet_${name}`, `wallet_${name}`, name)
        // const ua = window?.navigator?.userAgent ?? ''
        // const isBraavos = ua.includes('raavos')
        // const isAndroid = ua.indexOf('Android') !== -1
        // const data = `name:${name}:bua:${isBraavos}:and:${isAndroid}:mob:${isMobile}`
        // // console.log('DATA=', data)
        // if (network === 'mainnet-alpha') GAtrack('platform', 'connect', data)
    }

    // useEffect(() => {
    //     console.log('12312312')
    //     connect(true)
    // }, [])
    // useEffect(() => {
    //     if (props.secondary) return
    //     setTimeout(() => handleClick().catch((err) => console.error(err)), 100)
    // }, [])

    const lastNetworkRef = useRef(network)
    useEffect(() => {
        if (props.secondary) return
        ;(async () => {
            if (lastNetworkRef.current !== network) {
                lastNetworkRef.current = network
                if (network !== undefined) await onNetworkChange()
            } else {
                // just an account change
            }

            if (props.connected) props.connected()
        })()
    }, [network, address, props.secondary, props.connected])

    // SECONDARY
    // Handle wallet connect button inside the screen (aka secondary)
    if (props.secondary) {
        // If already connected no need to display button
        if (address !== '' || walletConnectionStatus === 2) {
            return <div></div>
        }

        // Secondary connect button - short-circuit all hooks
        let buttonText = 'Connect Wallet'
        let buttonDisabled = false
        if (walletConnectionStatus === 1) {
            buttonText = 'Connecting...'
            buttonDisabled = true
        }

        // Display button
        return (
            <div>
                <StyledLoadingButton fullWidth={true} disabled={buttonDisabled} onClick={handleClick}>
                    {/* <AccountBalanceWalletIcon fontSize='medium' sx={{ mr: 1 }} /> */}
                    <StyledButtonTypography sx={{ fontSize: isMobile ? 12 : 18 }}>{buttonText}</StyledButtonTypography>
                </StyledLoadingButton>
            </div>
        )
    }

    const handleConnectedClick = async () => {
        // open popup
        console.log('Connected Click')
        // setAnchorEl(event.currentTarget)
        setOpenConnectedOptions(true)
    }

    const handleNetworkClick = async () => {
        addToastMsg('Please change network in your wallet', 'warning')
    }

    const disconnect = async () => {
        console.log('disconnect disconnectdisconnectdisconnectdisconnect')
        walletDisconnect()
        setAutoConnect(false)
        setWalletConnectionStatus(0)
        window.localStorage.setItem('isDisconnected', 'true')
        if (props.disconnected) props.disconnected()
    }

    const walletStatus = () => {
        if (walletConnectionStatus === 2) {
            //console.log('Wallet is connected!', address)
            const icon = window.getStarknet?.()?.icon
            const isBraavos = window.getStarknet && window.getStarknet() && window.getStarknet()!.name === 'Braavos'
            return (
                <PrimaryButton className='h-[28px] lg:h-[34px] px-[8px] py-[2px]' size='sm' isDisabled={address === undefined} onClick={handleConnectedClick}>
                    <div className='flex justify-between items-center lg:text-[18px] text-[14px]'>
                        {isBraavos ? (
                            <BraavosLogo className='mr-1 w-6 h-6' />
                        ) : (
                            <img className='mr-1' src={icon ?? ArgentLogo} alt='' width={isMobile ? 20 : 24} height={isMobile ? 20 : 24} />
                        )}
                        <div>{starknetReadableAddress ? shortenText(starknetReadableAddress, 8, isMobile) : humanReadableHash(address!, isMobile)}</div>
                        {renderNetworkIcon()}
                    </div>
                </PrimaryButton>
            )
        } else if (walletConnectionStatus === 1) {
            //console.log('Wallet is being connected!', address)
            return (
                <Button
                    style={{
                        background: 'linear-gradient(90.23deg, #11D4ED -7.29%, #3770B8 53.52%)',
                        borderRadius: '8px'
                    }}>
                    <div>Connecting...</div>
                </Button>
            )
        } else {
            return (
                <Button
                    style={{
                        background: 'linear-gradient(90.23deg, #11D4ED -7.29%, #3770B8 53.52%)',
                        borderRadius: '8px'
                    }}
                    onClick={handleClick}>
                    <div className='text-white'>Connect Wallet</div>
                </Button>
            )
        }
    }

    const hrname = (networkName: Network) => {
        if (!networkName) return 'NOT CONNECTED'
        if (networkName.includes('mainnet')) return 'Mainnet'
        if (networkName.includes('goerli')) return 'Testnet'
        if (networkName.includes('sepolia')) return 'Testnet'
        if (networkName.includes('localhost')) return 'Devnet'
        return networkName
    }

    function renderNetworkIcon() {
        return (
            <div style={{ background: 'rgba(255, 255, 255, 0.13)' }} className='rounded-[24px] cursor-pointer ml-2 py-1 px-2'>
                <div className='flex items-center' onClick={handleNetworkClick}>
                    <img src={StarknetLogo} className='w-[14px] h-[14px] mr-1' />
                    <div className='lg:flex text-white text-[12px]'>{hrname(network as Network)}</div>
                </div>
            </div>
        )
    }
    // Main return
    return (
        <div>
            <div className='flex items-center'>
                {/* {renderNetworkIcon()} */}

                <div>{walletStatus()}</div>
            </div>

            {openConnectedOptions && (
                <ConnectedWalletOptions
                    setOpenConnectedOptions={setOpenConnectedOptions}
                    walletName={window.getStarknet?.()?.name!}
                    walletAddress={address!}
                    walletIcon={window.getStarknet?.()?.icon ?? ArgentLogo}
                    explorerUrl={getExplorerUrlBase(network!) + '/contract/' + address}
                    disconnect={disconnect}
                    // anchorEl={anchorEl}
                />
            )}
        </div>
    )
}

export default ConnectWallet
